import request from "./API";

export const ChangeFeedback = (userId, alignerStep,data) => {
  return request.post(`/admin-form/${userId}/progress/${alignerStep}/feedback`,data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
